<main class="page-body narrower">
  <mat-card
    appearance="outlined"
    class="top-progress center-content extra-padding extra-padding"
  >
    <div class="access-code-container" *ngIf="!hasValidToken">
      <img
        src="/assets/figure-no-results.svg"
        width="300px"
        data-testid="enter-access-code-img"
      />
      <h2 class="main-text" data-testid="main-text">Enter Access Code</h2>
      <h3 class="sub-text" data-testid="sub-text">
        Enter an access code to view/sign a special waste manifest.
      </h3>

      <div
        class="access-code-input-boxes"
        [ngClass]="{ 'invalid-access-code': this.hasTokenError }"
      >
        <input
          *ngFor="let inputValue of this.inputValues; let idx = index"
          (keyup)="this.updateChar($event, idx)"
          maxlength="1"
          matInput
          [disabled]="this.isLoading"
          [attr.data-testid]="'access-code-input-' + idx"
          class="access-code-input"
          [ngClass]="{ 'invalid-access-code': inputValue.isValid === false }"
        />
      </div>
      <mat-error
        *ngIf="this.hasTokenError"
        class="error-text"
        data-testid="access-code-error"
      >
        <strong>Access code incorrect/invalid. Please try again.</strong>
      </mat-error>
      <button
        data-testid="submit-access-code-button"
        mat-flat-button
        color="accent"
        (click)="submitCode()"
        [disabled]="!isAccessCodeFull()"
      >
        Continue
      </button>
    </div>

    <div class="access-code-container-success" *ngIf="enableOptionalFLow">
      <img
        src="/assets/high-five.svg"
        width="300px"
        data-testid="enter-email-img"
      />
      <h2 class="main-text" data-testid="enter-email-main-text">
        Would You Send Someone A Copy Of The Signed Manifest?
      </h2>
      <h3 class="sub-text" data-testid="enter-email-sub-text">
        Enter their email address below
      </h3>
      <form data-testid="enter-email-form" [formGroup]="form">
        <div class="input-container">
          <label
            >Email Address <span class="optional-span">(Optional)</span></label
          >
          <mat-form-field appearance="outline" floatLabel="always">
            <input
              data-testid="email-address-input"
              formControlName="emailAddress"
              matInput
            />
            <mat-error
              data-testid="invalid-email-error"
              *ngIf="form.get('emailAddress')?.hasError('email')"
            >
              Email Address is <strong>Invalid</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </form>
      <button
        data-testid="proceed-to-sign-button"
        mat-flat-button
        color="accent"
        (click)="navToSign()"
      >
        Proceed To Sign
      </button>
    </div>
  </mat-card>
</main>
